exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".span-container {\n  background-color: #DEEFEC;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  font-family: Graphik, Helvetica;\n  height: 56px;\n  margin-bottom: 5px;\n  width: 100%;\n  box-shadow: 0 0 0 8px #F2F2F2; }\n\n.details-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #DEEFEC;\n  padding: 16px;\n  margin: 0 auto;\n  border: 3px solid #F2F2F2;\n  border-left: 5px solid #1F8475;\n  border-radius: 5px; }\n\n#closeDetailsButton {\n  align-self: flex-end; }\n\n#cancel-appointment-btn {\n  background: transparent;\n  align-self: flex-end; }\n\n.title {\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 10px; }\n\n.details-label {\n  color: grey;\n  font-size: 11px;\n  margin-top: 20px; }\n\nul {\n  padding-left: 20px; }\n\n#location-circle {\n  background: transparent;\n  width: fit-content;\n  font-size: 10px;\n  padding: 0 10px; }\n\n.details-header {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/scheduler/appointmentDetails/details.scss
// module id = 1417
// module chunks = 0